<template>
  <div class="ls-img-dialog-component" v-if="visible">
    <div class="dialog-content">
      <img
        class="close-img"
        src="https://cdnws.51tyty.com/lstyty/file/2023/03/15/7d04d6daf01f5b6dd4b70eb1c8dc7dae.png"
        alt=""
        @click="cancel"
      />
      <slot name="content">默认内容</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    cancel(e) {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="less" scoped>
.ls-img-dialog-component {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
  .dialog-content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    .close-img {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
  }
}
</style>